// extracted by mini-css-extract-plugin
export default {"item":"TemplatesListItem_item__3sZOY","selected":"TemplatesListItem_selected__XPSbu"};